<template>
  <div class="page-content" id="forwardingDetails">
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>窜货结算</el-breadcrumb-item>
        <el-breadcrumb-item>转寄明细</el-breadcrumb-item>
      </el-breadcrumb>
      <section class="seaerch-wrapper">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="转寄日期" :label-width="formLabelWidth">
            <el-date-picker v-model="searchformDate" type="daterange" start-placeholder="开始日期" value-format="yyyy-MM-dd"
              end-placeholder="结束日期" range-separator="~" size="small">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否回款" :label-width="formLabelWidth">
            <el-select v-model="queryParams.status" filterable clearable placeholder="请选择" size="small">
              <el-option v-for="item in zhuanjiLIst" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品码" :label-width="formLabelWidth">
            <el-input placeholder="请输入" v-model="queryParams.productcodes" autocomplete="on" size="small"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="转寄快递单号" :label-width="formLabelWidth">
            <el-input placeholder="请输入" v-model="queryParams.forwardexpressnumber" autocomplete="on" size="small"
              clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="theQuery()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
      <div class="page">
        <div class="downBtn" style="margin-bottom: 8px;">
          <el-button size="small" @click="downLoadDataClick" :loading="LoadData">下载数据</el-button>
        </div>
        <el-table :data="tableData" ref="multipleTable" v-loading="dataLoading" element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading" @row-click="detailsDrawer" style="width: 100%;">
          <el-table-column label="是否回款" prop="date">
            <template slot-scope="scope">
              {{ scope.row.status == '1' ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column label="提报编号" width="140">
            <template slot-scope="scope">
              <div style="width: 126px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                {{ scope.row.chnumbers }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="产品码" width="200">
            <template slot-scope="scope">
              <div style="width: 173px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                {{ scope.row.productcodes }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="转寄产品总数" prop="forwardproduct_total_count">
          </el-table-column>
          <el-table-column label="转寄打款金额" prop="forwardoperation_price">
          </el-table-column>
          <el-table-column label="转寄日期" prop="forwardtime">
          </el-table-column>
          <el-table-column label="转寄快递单号" width="200">
            <template slot-scope="scope">
              <div style="width: 175px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                {{ scope.row.forwardexpress_number }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="转寄快递费（元）" prop="forwardexpress_fee">
          </el-table-column>
          <el-table-column label="转寄快递费凭证" width="300">
            <template slot-scope="scope">
              <div v-if="scope.row.forwardexpress_fee_pz">
                <div v-for="(item) in scope.row.forwardexpress_fee_pz.split(',')"
                  style="float: left;margin-right: 10px;">
                  <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 20rpx;">
                  </img>
                </div>
              </div>

            </template>
          </el-table-column>
          <el-table-column label="回款凭证" width="300">
            <template slot-scope="scope">
              <div v-if="scope.row.payment_collection_pz" style="width: 300px;">
                <div v-for="(item) in scope.row.payment_collection_pz.split(',')" style="float: left;margin-right: 10px;">
                  <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 20rpx;float: left;">
                  </img>
                </div>
              </div>

            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click.stop="detailsDrawer(scope.row)"
                :disabled="scope.row.status == '1'">上传汇款凭证</el-button>
            </template>
          </el-table-column>

        </el-table>
        <div v-show="this.tableData.length > 0">
          <pagination :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]" :total="totalNum"
            @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
          </pagination>
        </div>
        <!-- 新增 -->
        <el-dialog title="转寄详情" :visible.sync="downDataDialog" :close-on-click-modal="false" width="640px">
          <el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
            <div class="seaerch-wrapper">
              <el-form label-width="135px">
                <el-form-item label="提报编号：">
                  <div v-if="downData.chnumbers && downData.chnumbers.length > 0">
                    <div v-for="a in downData.chnumbers.split(',')">
                      {{ a }}
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="产品码：">
                  <div v-if="downData.productcodes && downData.productcodes.length > 0">
                    <div v-for="a in downData.productcodes.split(',')">
                      {{ a }}
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="转寄产品总数：">
                  {{ downData.forwardproductTotalCount }}
                </el-form-item>
                <el-form-item label="转寄打款金额：">
                  {{ downData.forwardoperationPrice }}
                </el-form-item>
                <el-form-item label="转寄日期：" :required="true">
                  {{ downData.forwardtime | fullTimeShort }}
                </el-form-item>
                <el-form-item label="转寄快递单号：">
                  {{ downData.forwardexpressNumber }}
                </el-form-item>
                <el-form-item label="转寄快递费：">
                  {{ downData.forwardexpressFee }}
                </el-form-item>
                <el-form-item label="转寄快递费凭证：">
                  <div v-if="downData.forwardexpressFeePz">
                    <div v-for="(item) in downData.forwardexpressFeePz.split(',')"
                      style="float: left;margin-right: 10px;" @click="jump(item)">
                      <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 20rpx;cursor: pointer;">
                      </img>
                    </div>
                  </div>

                </el-form-item>
                <el-form-item label="回款凭证：">
                  <el-upload class="avatar-uploader" action="/hcm/hcmWorkOrder/headImgUploadPRS"
                    list-type="picture-card" :file-list="fileList" :before-upload="beforeUpload" :limit="9"
                    :on-exceed="handleExceed" :on-success="handleUploadSuccess" :on-remove="handleRemove"
                    accept="image/png, image/jpg" multiple ref="elUploadforwardingDetails"
                    v-if="downData.status == '0'">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div v-else>
                    <div v-if="downData.paymentCollectionPz">
                      <div v-for="(item) in downData.paymentCollectionPz.split(',')"
                        style="float: left;margin-right: 10px;" @click="jump(item)">
                        <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 20rpx;cursor: pointer;">
                        </img>
                      </div>
                    </div>

                  </div>
                </el-form-item>
              </el-form>
            </div>
          </el-row>
          <span slot="footer">
            <el-button size="small" class="g-confirm-btn" :loading="downloadLoading" @click="determine" type="primary"
              v-if="downData.status == '0'">确
              定</el-button>
            <el-button size="small" class="g-cancel-btn" @click="downDataDialog = false">取 消</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "../../components/dataTable/pagination";
import axios from 'axios'
export default {
  data() {
    return {
      queryParams: {
        status: '',
        productcodes: '',
        forwardexpressnumber: '',
      },
      fileList: [],
      LoadData: false,
      downDataDialog: false,
      downloadLoading: false,
      downData: {
        paymentcollectionpz: null,
        id: null,
      },
      dataLoading: false,
      pageNo: 1,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      searchformDate: [],
      totalNum: 100,
      formLabelWidth: '120px',
      zhuanjiLIst: [{
        name: '是',
        value: '1'
      }, {
        name: '否',
        value: '0'
      }],
    }
  },
  mounted() {
    this.theQuery()
  },
  methods: {
    jump(url) {
      window.open(url)
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前最多允许上传 9 张图片，您已选择了 ${fileList.length} 张，无法继续上传。`);
    },
    // 详情
    detailsDrawer(row) {
      this.downData = {}
      let params = {
        id: row.id
      }
      fetch({
        url: "hcm/HcmReportInfoForward/findById",
        method: "get",
        noFormat: true,
        params: params,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        if (res.status == '10000') {
          this.downData = res.data.hcmReportInfoShipping;
          this.downDataDialog = true
        }
      }).catch(err => {

      })

    },
    // 新增确定
    determine() {
      if (!this.downData.forwardtime) {
        this.$message({
          message: '请选择转寄时间',
          type: 'warning'
        });
        return
      }
      this.downloadLoading = true
      this.downData.paymentcollectionpz = this.fileList.join(',')
      let data = {
        paymentcollectionpz: this.downData.paymentcollectionpz,
        id: this.downData.id,
      }
      let that = this
      axios({
        method: 'post',
        url: 'hcm/HcmReportInfoForward/updatePz',
        headers: {
          'Content-type': 'application/json;charset=UTF-8'
        },
        params: data,
      }).then(function (response) {
        if (response.data.status == "10000") {
          that.downDataDialog = false
          // that.downloadLoading = false
          that.$message({
            type: "success",
            message: "成功!"
          });
          that.theQuery()
        } else {
          that.downDataDialog = false
          // that.downloadLoading = false
          that.$message.error(response.data.message)
        }
      })
    },
    // 删除图片
    handleRemove(file, fileList) {
      if (file.response) {
        const urlToRemove = file.response.data.data;
        this.fileList = this.fileList.filter(url => url !== urlToRemove);
      }
    },
    handleUploadSuccess(res) {
      this.fileList.push(res.data.data)
    },
    beforeUpload(file) {
      let name = file.name;
      let p = /\.(jpg|png)$/
      if (!p.test(name)) {
        this.$message({
          showClose: true,
          message: '请上传符合要求格式的文件',
          type: 'warning'
        });
      }
      let limitSize = 1 * 1024 * 1024 * 50;
      if (file.size > limitSize) {
        this.$message({
          showClose: true,
          message: '请上传大小小于50M的文件',
          type: 'warning'
        });
      }
      if (this.fileList.length >= 9) {
        this.$message.warning('已达最大上传数量（9张），无法继续上传。');
        return false;
      }
      if (p.test(name) && file.size < limitSize) {
        return true;
      }
      return false;
    },
    // 下载数据
    downLoadDataClick() {
      this.LoadData = true
      let params = {
        ...this.queryParams
      }
      if (this.searchformDate && this.searchformDate.length == 2) {
        params.starttime = this.$options.filters['fullTime'](this.searchformDate[0]).substring(0, 10)
        params.endtime = this.$options.filters['fullTime'](this.searchformDate[1]).substring(0, 10)
      }
      fetch({
        url: "/hcm/HcmReportInfoForward/findPageReportInfoForwardDownload",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "blob"
      })
        .then((res) => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '转寄明细.xlsx')
          document.body.appendChild(link)
          link.click()
          this.LoadData = false
        })
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = `${val}`
      this.theQuery()
    },
    // 翻页
    handleSizeChange(val) {
      this.pageSize = `${val}`
      this.theQuery()
    },
    // 数据源
    theQuery() {
      this.dataLoading = true
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.queryParams
      }
      if (this.searchformDate && this.searchformDate.length == 2) {
        params.starttime = this.$options.filters['fullTime'](this.searchformDate[0]).substring(0, 10)
        params.endtime = this.$options.filters['fullTime'](this.searchformDate[1]).substring(0, 10)
      }
      fetch({
        url: "hcm/HcmReportInfoForward/findPageReportInfoForward",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.dataLoading = false
          this.tableData = res.data.content
          this.totalNum = res.data.totalElements
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
  },
  components: {
    pagination
  }
}
</script>
<style lang="scss">
#forwardingDetails {
  .el-table__empty-text {
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }

  .el-table th {
    background-color: #f2f6fe !important;
    color: #4a4b4c;
  }

  .page {
    padding: 20px;
    margin: 10px 0px 0px 0px;
    background-color: white;
  }

  #dialog {
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }

    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }

  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }

  .el-button--TheCustom:hover {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }

  .downBtn {
    display: flex;
    justify-content: flex-start;
  }

  .threeHa {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>
